
function addSourceToVideo(element, src, type) {
    var source = document.createElement('source');
    source.src = src;
    source.type = type;
    element.appendChild(source);
}


function init() {

	const $video = $('.js-homepage-video');
	if (!$video.length) return;



	const mp4 = $video.data('src-mp4');
	const webm = $video.data('src-webm');
	const video = $video.get(0);

	if (mp4) addSourceToVideo(video, mp4, 'video/mp4');
	if (webm) addSourceToVideo(video, webm, 'video/webm');

	video.load();
	video.play();

	video.addEventListener('ended', () => {

		const hasAttr = video.hasAttribute('loop');
		const attr = video.getAttribute('loop');

		if (
			!hasAttr ||
			(hasAttr && attr === 'false')
		) {
			video.pause();
		}
	});
}

export default {
	init
}